/**
 * 公用项目配置参数，不能删除
 */

// 项目名称
export const projectName = ''
// 运行模式，dev = 本地调试，build-dev = 上传开发服务器，build-pro = 上传生产服务器
export const runType = 'build-pro'
// 开发服务器地址
export const devServer = 'http://xm.lcxxjs.cn/api/'
// 生产服务器地址
export const proServer = 'http://xm.lcxxjs.cn/api/'


/**
 * 自定义的项目配置参数
 */

// 气站对应的编号
export const stationMap = {
    1: '城乡燃气',
    2: '永液燃气',
    3: '中燃燃气',
    4: '楠溪燃气',
    // 总站
    5: '锡盟燃气'
}
// 支付方式
export const payment = {
    1: '现金',
    2: '欠款',
    3: '月结',
    4: '微信',
    5: '支付宝'
}
// 卡基础状态
export const cardBasicType = {
    1: '正常',
    2: '作废'
}
// 卡用户状态
export const cardUserType = {
    1: '已激活',
    2: '未激活',
    3: '退回中',
    4: '已退回'
}
// 卡使用状态 / 卡经销商状态
export const cardUsingType = {
    1: '已分配',
    2: '未分配',
    3: '申请退回',
    4: '退回中',
    5: '已退回'
}